import React from 'react';

import { cn } from 'common/style/utils';

type Props = React.ComponentProps<'label'> & {
  isRequired?: boolean;
};

const AdminOnboardingFieldLabel = ({ isRequired, children, className, ...props }: Props) => {
  return (
    <label className={cn('text-lg text-gray-110', className)} {...props}>
      {children} {isRequired && <span className="text-[length:inherit] text-tomato-90">*</span>}
    </label>
  );
};

export default AdminOnboardingFieldLabel;
